import { Component, OnInit, OnDestroy } from '@angular/core';
import { BlogDataService } from '@shared/service/blog-data.service';
import { BlogDataModel, SingelBlogModel } from '@shared/models/blog.model';
import { Router } from '@angular/router';
import { blogData } from '@shared/data/blog/blog-basic/split';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-column-right-sidebar',
  templateUrl: './column-right-sidebar.component.html',
  styleUrls: ['./column-right-sidebar.component.scss']
})
export class ColumnRightSidebarComponent implements OnDestroy {

  public blogData: BlogDataModel;
  public subscription: Subscription;
  constructor(
    public blogDataService: BlogDataService,
    private router: Router) {
    this.blogData = blogData.find(x => x.category === 'thought');
    // console.log(this.blogData);
    // this.subscription = this.blogDataService.dataUpdated$.subscribe(data => this.blogData = data);
  }

  setSelectedArticle(blog: SingelBlogModel) {
    this.blogDataService.selectedArticle = blog;
    this.router.navigate(['/blog-detail', blog.Id]);
  }

  ngOnDestroy() { }
}
